import { and, or } from 'tio-ui/utilities';
import { fn } from '@ember/helper';
import { Footer, Modal } from 'tio-ui/components/modal';
import { t } from 'ember-intl';
import { Textarea } from 'tio-ui/components/forms';
import type { Task } from 'ember-concurrency';
import Component from '@glimmer/component';

interface TioConfirmConfirmModalSignature {
  Args: {
    cancel: () => void;
    changelog: unknown;
    didSave?: () => void;
    hasSubmitted: boolean;
    modalBodyText?: string;
    modalTitle?: string;
    show: boolean;
    submitAction: Task<void, []>;
    submitButtonText: string;
    serverErrorMessages?: string[];
  };
}

export default class TioConfirmConfirmModalComponent extends Component<TioConfirmConfirmModalSignature> {
  submit = () => {
    try {
      this.args.submitAction.perform();
      this.args.cancel();
    } catch (error) {
      console.error(error);
    }
  };
  <template>
    <Modal @isOpen={{@show}} @onClose={{@cancel}} as |m|>
      <m.Header>{{@modalTitle}}</m.Header>
      <m.Body>
        <form>
          <h2>{{@modalBodyText}}</h2>
          <div>
            <Textarea
              data-legacy-input
              @label={{t "common.reason"}}
              @value="{{@changelog}}"
              @onInput={{fn (mut @changelog)}}
              class="mb-4 w-full"
              required="true"
            />
          </div>
        </form>
        {{#if (and @hasSubmitted @serverErrorMessages.length)}}
          <ul class="text-red-600 my-2">
            {{#each @serverErrorMessages as |message|}}
              <li class="whitespace-normal">{{message}}</li>
            {{/each}}
          </ul>
        {{/if}}
      </m.Body>
      <m.Footer>
        <Footer
          @isRunning={{@submitAction.isRunning}}
          @onCancel={{@cancel}}
          @onSubmit={{this.submit}}
          @submitText={{or @submitButtonText (t "common.save")}}
        />
      </m.Footer>
    </Modal>
  </template>
}
